import StatsMenu from './StatsMenu';

export default StatsMenu;
